const request = require('../request-utils.js');

/**
 * 添加吉客云日志 
 * @param {*} businessType 
 * @param {*} businessId 
 * @param {*} logDetail 
 */
const addJackyunLog = (businessType, businessId, logDetail) => {
	return new Promise((resolve, reject) => {
		request.default.jackyunPost({
			method: "jmall.jackyunlog.saveloginfo",
			jsonStr: JSON.stringify({
				businessType,
				businessId,
				logDetail,
				operationName: "客户（pc）"
			})
		}, (res) => {
			if (res && res.code != 200) {
				console.log("添加吉客云日志失败：", res);
			}
			resolve(res && res.code == 200);
		})
	});
}


export {
	addJackyunLog,
}